import { Link } from 'react-router-dom';

export default function Unauthorized() {
  return (
    <div className="unauthorized-page">
      <i className="bi bi-shield-exclamation" />
      <h2>Accès refusé</h2>
      <p>Vous n'avez pas les permissions nécessaires pour accéder à cette page.</p>
      <Link to="/" className="btn btn-primary"><i className="bi bi-arrow-left" /> Retour au tableau de bord</Link>
    </div>
  );
}
